import { createAction, props } from '@ngrx/store';
import { Insurance } from '../_models/insurance';

// Action types
export const loadInsurances = createAction('[Insurance] Load Insurances');
export const loadInsurancesSuccess = createAction(
  '[Insurance] Load Insurances Success',
  props<{ insurances: Insurance[] }>()
);
export const loadInsurancesFailure = createAction(
  '[Insurance] Load Insurances Failure',
  props<{ error: any }>()
);

export const addInsurance = createAction(
  '[Insurance] Add Insurance',
  props<{ insurance: Insurance }>()
);
export const addInsuranceSuccess = createAction(
  '[Insurance] Add Insurance Success',
  props<{ insurance: Insurance }>()
);
export const addInsuranceFailure = createAction(
  '[Insurance] Add Insurance Failure',
  props<{ error: any }>()
);

export const updateInsurance = createAction(
  '[Insurance] Update Insurance',
  props<{ insurance: Insurance }>()
);
export const updateInsuranceSuccess = createAction(
  '[Insurance] Update Insurance Success',
  props<{ insurance: Insurance }>()
);
export const updateInsuranceFailure = createAction(
  '[Insurance] Update Insurance Failure',
  props<{ error: any }>()
);

export const deleteInsurance = createAction(
  '[Insurance] Delete Insurance',
  props<{ id: number }>()
);
export const deleteInsuranceSuccess = createAction(
  '[Insurance] Delete Insurance Success',
  props<{ id: number }>()
);
export const deleteInsuranceFailure = createAction(
  '[Insurance] Delete Insurance Failure',
  props<{ error: any }>()
);
